import React from 'react';
import { Typography } from 'antd';
import ReactMarkdown from 'react-markdown';
import { AnalysisResult, AnalysisStatus } from '../../../types';
import './markdown.css';

const { Title, Text } = Typography;

interface CommonIssuesProps {
  results: AnalysisResult;
  status: AnalysisStatus;
}

const CommonIssues: React.FC<CommonIssuesProps> = ({ results, status }) => {
  const { common_issues } = results;

  if (status === 'error') {
    return <Text>There was an unexpected error with common issues, once the report is complete, please rerun the analysis.</Text>;
  } else if (status === 'skipped') {
    return <Text>Common issues were skipped by the user.</Text>;
  }

  if (!common_issues) {
    return <Text>No common issues data available.</Text>;
  }

  const content = common_issues.cleaned_content;

  return (
    <div>
      {content ? (
        <div className="markdown-content">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      ) : (
        <Text type="secondary">Analysis in progress...</Text>
      )}
    </div>
  );
};

export default CommonIssues;